import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { deepMix } from '@antv/util';
import { subObject } from '../utils/helper';
import { selectionOf } from '../utils/scale';
import { brush as createBrush } from './brushHighlight';
import { selectPlotArea } from './utils';
// Mock dblclick events.
function dblclick() {
  var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 300;
  var preTimeStamp = null;
  return function (e) {
    var timeStamp = e.timeStamp;
    if (preTimeStamp !== null && timeStamp - preTimeStamp < interval) {
      preTimeStamp = timeStamp;
      return true;
    }
    preTimeStamp = timeStamp;
    return false;
  };
}
export function brushFilter(root, _a) {
  var filter = _a.filter,
    reset = _a.reset,
    brushRegion = _a.brushRegion,
    optionalExtent = _a.extent,
    reverse = _a.reverse,
    emitter = _a.emitter,
    scale = _a.scale,
    coordinate = _a.coordinate,
    selection = _a.selection,
    _a$series = _a.series,
    series = _a$series === void 0 ? false : _a$series,
    rest = __rest(_a, ["filter", "reset", "brushRegion", "extent", "reverse", "emitter", "scale", "coordinate", "selection", "series"]);
  var brushStyle = subObject(rest, 'mask');
  var _root$getBBox = root.getBBox(),
    rootWidth = _root$getBBox.width,
    rootHeight = _root$getBBox.height;
  var extent = optionalExtent ? optionalExtent : [0, 0, rootWidth, rootHeight];
  var isDblclick = dblclick();
  var brush = createBrush(root, Object.assign(Object.assign({}, brushStyle), {
    extent: extent,
    brushRegion: brushRegion,
    reverse: reverse,
    brushcreated: brushcreated
  }));
  root.addEventListener('click', click);
  // Filter when brush created.
  function brushcreated(x, y, x1, y1, event) {
    event.nativeEvent = true;
    filter(selection(x, y, x1, y1), event);
    brush.remove();
  }
  // Reset when dblclick.
  function click(e) {
    if (isDblclick(e)) {
      e.nativeEvent = true;
      reset(e);
    }
  }
  var onFilter = function onFilter(_ref) {
    var nativeEvent = _ref.nativeEvent,
      data = _ref.data;
    if (nativeEvent) return;
    var selection = data.selection;
    filter(selection, {
      nativeEvent: false
    });
  };
  emitter.on('brush:filter', onFilter);
  return function () {
    brush.destroy();
    emitter.off('brush:filter', onFilter);
    root.removeEventListener('click', click);
  };
}
export function BrushFilter(_a) {
  var _this = this;
  var _a$hideX = _a.hideX,
    hideX = _a$hideX === void 0 ? true : _a$hideX,
    _a$hideY = _a.hideY,
    hideY = _a$hideY === void 0 ? true : _a$hideY,
    rest = __rest(_a, ["hideX", "hideY"]);
  return function (target, viewInstances, emitter) {
    var container = target.container,
      view = target.view,
      viewOptions = target.options,
      update = target.update,
      setState = target.setState;
    var plotArea = selectPlotArea(container);
    var defaultOptions = {
      maskFill: '#777',
      maskFillOpacity: '0.3',
      maskStroke: '#fff',
      unhighlightedOpacity: 0.5,
      reverse: false
    };
    var filtered = false;
    var filtering = false;
    var newView = view;
    var scale = view.scale,
      coordinate = view.coordinate;
    return brushFilter(plotArea, Object.assign(Object.assign({
      brushRegion: function brushRegion(x, y, x1, y1) {
        return [x, y, x1, y1];
      },
      selection: function selection(x, y, x1, y1) {
        var _newView = newView,
          scale = _newView.scale,
          coordinate = _newView.coordinate;
        return selectionOf(x, y, x1, y1, scale, coordinate);
      },
      filter: function filter(selection, event) {
        return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee() {
          var _selection, domainX, domainY, newState;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (!filtering) {
                  _context.n = 1;
                  break;
                }
                return _context.a(2);
              case 1:
                filtering = true;
                // Update the domain of x and y scale to filter data.
                _selection = _slicedToArray(selection, 2), domainX = _selection[0], domainY = _selection[1];
                setState('brushFilter', function (options) {
                  var marks = options.marks;
                  var newMarks = marks.map(function (mark) {
                    return deepMix({
                      // Hide label to keep smooth transition.
                      axis: Object.assign(Object.assign({}, hideX && {
                        x: {
                          transform: [{
                            type: 'hide'
                          }]
                        }
                      }), hideY && {
                        y: {
                          transform: [{
                            type: 'hide'
                          }]
                        }
                      })
                    }, mark, {
                      // Set nice to false to avoid modify domain.
                      scale: {
                        x: {
                          domain: domainX,
                          nice: false
                        },
                        y: {
                          domain: domainY,
                          nice: false
                        }
                      }
                    });
                  });
                  return Object.assign(Object.assign({}, viewOptions), {
                    marks: newMarks,
                    clip: true
                  });
                });
                // Emit event.
                emitter.emit('brush:filter', Object.assign(Object.assign({}, event), {
                  data: {
                    selection: [domainX, domainY]
                  }
                }));
                _context.n = 2;
                return update();
              case 2:
                newState = _context.v;
                newView = newState.view;
                filtering = false;
                filtered = true;
              case 3:
                return _context.a(2);
            }
          }, _callee);
        }));
      },
      reset: function reset(event) {
        if (filtering || !filtered) return;
        // Emit event.
        var scale = view.scale;
        var scaleX = scale.x,
          scaleY = scale.y;
        var domainX = scaleX.getOptions().domain;
        var domainY = scaleY.getOptions().domain;
        emitter.emit('brush:filter', Object.assign(Object.assign({}, event), {
          data: {
            selection: [domainX, domainY]
          }
        }));
        filtered = false;
        newView = view;
        setState('brushFilter');
        update();
      },
      extent: undefined,
      emitter: emitter,
      scale: scale,
      coordinate: coordinate
    }, defaultOptions), rest));
  };
}